export default (props) => (
   /**
   * Icone da ferramenta de Clip.
   * Responsavel por iniciar operação de clip sobre 
   * feições de camada
   */

   <svg 
      width="25" 
      height="21" 
      viewBox="0 0 25 21" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
   >
      <path
         d="M13.0487 3.9987L13.5664 3.10212L14.2159 3.47712L14.6041 2.80469C14.6352 2.75085 14.6745 2.71958 14.7161 2.70123L14.4133 2.01506C14.6713 1.90123 14.97 1.90123 15.2279 2.01506L14.9252 2.70123C14.9668 2.71959 15.0061 2.75085 15.0371 2.80469L15.4254 3.47712L16.0749 3.10212L16.5925 3.9987L15.943 4.3737L16.7195 5.71858L17.369 5.34358L17.8866 6.24016L17.2371 6.61516L18.0136 7.96003L18.6631 7.58503L19.1807 8.48161L18.5312 8.85661L19.3077 10.2015L19.9572 9.82648L20.4748 10.7231L19.8253 11.0981L20.6018 12.4429L21.2513 12.0679L21.7689 12.9645L21.1194 13.3395L21.5077 14.012C21.5387 14.0658 21.5462 14.1154 21.5413 14.1607L22.2869 14.2415C22.2565 14.5218 22.1071 14.7805 21.8796 14.947L21.4367 14.3417C21.4 14.3686 21.3533 14.387 21.2911 14.387H20.5147V15.137H19.4794V14.387H17.9265V15.137H16.8912V14.387H15.3383V15.137H14.303V14.387H12.7501V15.137H11.7148V14.387H10.1619V15.137H9.12657V14.387H8.35011C8.28794 14.387 8.24123 14.3686 8.20453 14.3417L7.76168 14.947C7.53412 14.7805 7.38477 14.5218 7.35437 14.2415L8.09999 14.1607C8.09509 14.1154 8.10252 14.0658 8.13361 14.012L8.52184 13.3395L7.87232 12.9645L8.38996 12.0679L9.03948 12.4429L9.81594 11.0981L9.16642 10.7231L9.68406 9.82648L10.3336 10.2015L11.11 8.85661L10.4605 8.48161L10.9782 7.58503L11.6277 7.96003L12.4041 6.61516L11.7546 6.24016L12.2723 5.34358L12.9218 5.71858L13.6983 4.3737L13.0487 3.9987Z"
         stroke="#6E7A94"
         strokeWidth="1.5"
         strokeDasharray="1.5 1"
      />
      <rect 
         x="1.11963"
         y="8.60156"
         width="12.4441"
         height="11.5145"
         rx="1.25"
         stroke="#6E7A94"
         strokeWidth="1.5"
         strokeDasharray="1.5 1"
      />
      <path
         fillRule="evenodd"
         clipRule="evenodd"
         d="M14.3138 15.1291H8.35012C7.58032 15.1291 7.0992 14.2958 7.4841 13.6291L10.8198 7.85156H12.3138C13.4183 7.85156 14.3138 8.74699 14.3138 9.85156V15.1291Z"
         fill="#BEC7DC"
      />
   </svg>


);
